import Vue from 'vue';
import vueDatepicker from 'vue2-datepicker';
import Multiselect from 'vue-multiselect';

Vue.component('multiselect', Multiselect);
Vue.component(
    'vue-google-autocomplete',
    require('./vendor/google-auto-complete/VueGoogleAutocomplete.vue'),
);
Vue.component('dropzone', require('./vendor/dropzone/vue-dropzone.vue'));
Vue.component('date-picker', require('./vendor/date-picker.vue'));
Vue.component('loading-spinner', require('./fa-loading-spinner.vue'));
Vue.component('editable', require('./vendor/x-editable/editable.vue'));
Vue.component('bs3-datepicker', require('./vendor/bs3-datepicker.vue'));
Vue.component('report-filter', require('./report-filter.vue'));
Vue.component('vue-datepicker', vueDatepicker);

// selector
Vue.component('outlet-selector', require('./selector/outlet-selector.vue'));
Vue.component('tags-selector', require('./selector/tags-selector.vue'));
Vue.component('stock-selector', require('./selector/stock-selector.vue'));
Vue.component('supplier-selector', require('./selector/supplier-selector.vue'));
Vue.component(
    'stock-inventory-selector',
    require('./selector/stock-inventory-selector.vue'),
);

// settings
Vue.component('outlet-list', require('./outlet/outlet-list.vue'));

// Stock
Vue.component(
    'stock-inventory-list',
    require('./stock/stock-inventory-list.vue'),
);

Vue.component(
    'stock-composite-list',
    require('./stock/stock-composite-list.vue'),
);

// audit trail
Vue.component(
    'audit-trail-list',
    require('./audit_trail/audit-trail-list.vue'),
);

// Bootsrap Modal
Vue.component('aside-flatkit', require('./aside-flatkit.vue'));
Vue.component('modal-full', require('./modal-full.vue'));
Vue.component('modal', require('./modal/modal.vue'));

Vue.component('dashboard', require('./dashboard/dashboard.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components/components.js